angelCake.hexToRGB = function (hex,opacity){
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? "rgba("+parseInt(result[1], 16)+","+parseInt(result[2], 16)+","+parseInt(result[3], 16)+","+opacity+")" : null;
  };

  
  angelCake.numbersToCommas = function(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  

  angelCake.parseDataForAMCharts = function(myTable){
    var output = {
      "dataProvider" : [],
      "Labels" : [],
      "Labels Title" : myTable.table_header[0].column_label,
      "Title" : myTable.table_options.table_title,
      "Sub Title" : myTable.table_options.table_subtitle
    };
    _.forEach(myTable.table_body, function(item,index){
      var arr = [];
      var temp = {};
      _.forEach(item['td'],function(subitem,index2){
          temp[myTable.table_header[index2].column_label] = subitem;
      });
      output['dataProvider'].push(temp);
    });
    return output;
  };
  angelCake.generateChart = function(type,divID,chartData){
    var chart_graphs = [];
    var label_position = 'top';
    var chart_type = "serial";
    var chart_rotate = false;
    var chart_show_legend = false;
    var newChartData =  angelCake.parseDataForAMCharts(chartData);
    var chart_animation = 'easeInSine';
    var chart_animation_duration = 0.5;
    var show_vertical_labels = false;
    if(chartData.table_options.chart_type =='funnel'){
      label_position = 'right';
      chart_type = "funnel";
      chart_rotate = false;
      chart_animation = 'easeInSine';
      chart_animation_duration = 0.5;
   
    }
    if(chartData.table_options.chart_type =='donut'){
      label_position = 'right';
      chart_rotate = false;
      chart_animation = 'easeInSine';
      chart_animation_duration = 0.5;
   
    }
    if(chartData.table_options.chart_type =='pie'){
      label_position = 'right';
      chart_rotate = false;
      chart_animation = 'easeInSine';
      chart_animation_duration = 0.5;
   
    }
    if(chartData.table_options.chart_type =='vertical-bar'){
      label_position = 'top';
      chart_type = "serial";
      chart_rotate = false;
      chart_animation = 'easeInSine';
      chart_animation_duration = 0.5;
      _.forEach(chartData.table_header,function(item,index){
        if(index!=0){
          chart_graphs.push({
            "balloonText": item.column_label+": <b>[[value]]</b>",
            "fillAlphas": 1,
            "lineAlpha": 0,
            "type": "column",
            "title" : item.column_label,
            "cornerRadiusTop" : 3,
            "valueField": item.column_label,
            "labelText": "[[value]]",
            "labelPosition": label_position,
            "showBalloon" : true,
            "fixedColumnWidth": 24
          });
        }
      });
    }

    if(chartData.table_options.chart_type =='vertical-bar-stacked'){
      label_position = 'top';
      chart_type = "serial";
      chart_rotate = false;
      chart_animation = 'easeInSine';
      chart_animation_duration = 0.5;
      _.forEach(chartData.table_header,function(item,index){
        if(index!=0){
          chart_graphs.push({
            "balloonText": item.column_label+": <b>[[value]]</b>",
            "fillAlphas": 1,
            "lineAlpha": 0,
            "type": "column",
            "title" : item.column_label,
            "cornerRadiusTop" : 3,
            "valueField": item.column_label,
            "labelText": "",
            "labelPosition": label_position,
            "showBalloon" : true,
            "fixedColumnWidth": 24
          });
        }
      });
    }

   
    if(chartData.table_options.chart_type =='horizontal-bar'){
      label_position = 'right';
      chart_type = "serial";
      chart_rotate = true;
      chart_animation = 'easeInSine';
      chart_animation_duration = 0.5;
      _.forEach(chartData.table_header,function(item,index){
        if(index!=0){
          chart_graphs.push({
            "balloonText": item.column_label+": <b>[[value]]</b>",
            "fillAlphas": 1,
            "lineAlpha": 0,
            "type": "column",
            "title" : item.column_label,
            "cornerRadiusTop" : 3,
            "valueField": item.column_label,
            "labelText": "[[value]]",
            "labelPosition": label_position,
            "showBalloon" : true,
            "fixedColumnWidth": 24
          });
        }
      });
    }

    if(chartData.table_options.chart_type =='horizontal-bar-stacked'){
      label_position = 'right';
      chart_type = "serial";
      chart_rotate = true;
      chart_animation = 'easeInSine';
      chart_animation_duration = 0.5;
      _.forEach(chartData.table_header,function(item,index){
        if(index!=0){
          chart_graphs.push({
            "balloonText": item.column_label+": <b>[[value]]</b>",
            "fillAlphas": 1,
            "lineAlpha": 0,
            "type": "column",
            "title" : item.column_label,
            "cornerRadiusTop" : 3,
            "valueField": item.column_label,
            "labelText": "",
            "labelPosition": label_position,
            "showBalloon" : true,
            "fixedColumnWidth": 24
          });
        }
      });
    }

    if(chartData.table_options.chart_type =='line-chart'){
      label_position = 'right';
      chart_type = "serial";
      chart_rotate = false;
      chart_animation = 'easeInSine';
      chart_animation_duration = 0;
      show_vertical_labels = true;
      _.forEach(chartData.table_header,function(item,index){
        if(index!=0){
          chart_graphs.push({
            "balloonText": item.column_label+": <b>[[value]]</b>",
            "lineAlpha": 1,
            "type": "smoothedLine",
            "title" : item.column_label,
            "valueField": item.column_label,
            "showBalloon" : true,
            "lineColor": angelCake.colourArray[index-1],
            "bullet" : "round",
            "bulletBorderColor" : '#ffffff',
            "bulletBorderThickness" : 2,
            "lineThickness" : 4,
            "bulletSize" : 12,
            "fillAlphas" : 0
          });
        }
      });
    }
      

    

   
  
    
    if(_.size(newChartData.dataProvider[0])<3){

      _.forEach(newChartData.dataProvider,function(item,index){
        item.color = angelCake.colourArray[index];
      });
      _.forEach(chart_graphs,function(item,index){
        if(chartData.table_options.chart_type !='line-chart'){
          item['fillColorsField']="color"; 
        }

      });
    }else{
      chart_show_legend = true;
    }
   
    var amChartConfig = {
      "type": chart_type,
      "dataProvider" : newChartData.dataProvider,
      "colors" : angelCake.colourArray,
      "rotate": chart_rotate,
      "startEffect" : chart_animation,
      "startDuration": chart_animation_duration,
      "gridAboveGraphs" :false,
      "fontSize" :12,
      "legend": {
        "enabled" : chart_show_legend,
        "align" : "center",
        "color" : "#4d4c4c" //colour of legend text
      },

      "valueAxes": [ {
        "gridColor": "#cccccc",
        "gridAlpha": 0.2,
        "dashLength": 0,
        "tickLength": 0,
        "labelsEnabled" : show_vertical_labels,
        "axisAlpha": 0
      } ],
      
      "graphs": chart_graphs,
    
      "categoryField": newChartData['Labels Title'],

      "categoryAxis": {
        "gridPosition": "start",
        "gridAlpha": 0,
        "tickPosition": "start",
        "dashLength": 0,
        "tickLength": 0,
        "labelRotation" : 0,
        "startOnAxis": false,
        "axisColor" : "#ffffff",
        "axisAlpha": 1,
       // "color" : "#4d4c4c", //colour of bottom labels
        "autoWrap" : true
        //"autoRotateAngle" : 45,
        //"autoRotateCount" : 10
      },
      "export": {
        "enabled": false
      }

    };
    if(chartData.table_options.chart_type=='pie'){
      amChartConfig.type='pie';
      amChartConfig.titleField = chartData.table_header[0].column_label;
      amChartConfig.valueField = chartData.table_header[1].column_label;
      amChartConfig.legend.enabled = false;
      amChartConfig.radius = "43%";
      amChartConfig.labelRadius = 5;
      amChartConfig.labelText = "[[title]]";
    }
    if(chartData.table_options.chart_type=='donut'){
      amChartConfig.type='pie';
      amChartConfig.titleField = chartData.table_header[0].column_label;
      amChartConfig.valueField = chartData.table_header[1].column_label;
      amChartConfig.legend.enabled = false;
      amChartConfig.radius = "43%";
      amChartConfig.labelRadius = 5;
      amChartConfig.innerRadius = "60%";
      amChartConfig.labelText = "[[title]]";
    }
    if(chartData.table_options.chart_type=='line-chart'){
    
    		amChartConfig.legend.enabled = true;
    	
     
     amChartConfig.categoryAxis.startOnAxis = true;
     amChartConfig.categoryAxis.labelOffset = 10;
     amChartConfig.categoryAxis.labelRotation = 45;
     amChartConfig.categoryAxis.axisColor =  "#cccccc";
    }
    
    if(chartData.table_options.chart_type=='funnel'){
      amChartConfig.titleField = chartData.table_header[0].column_label;
      amChartConfig.valueField = chartData.table_header[1].column_label;
      amChartConfig.startX = 0;
      amChartConfig.labelPosition = "right";
      amChartConfig.legend.enabled = true;
      amChartConfig.labelText = "[[value]]";
      amChartConfig.baseWidth = "65%";
      amChartConfig.labelsEnabled = false;
    }
     if(chartData.table_options.chart_type =='vertical-bar-stacked' || chartData.table_options.chart_type =='horizontal-bar-stacked'){
     	amChartConfig.valueAxes[0].stackType = "regular";
     	amChartConfig.valueAxes[0].centerLabels = true;

    }
    if(chartData.table_options.chart_type =='horizontal-bar' || chartData.table_options.chart_type =='horizontal-bar-stacked'){
    	amChartConfig.categoryAxis.gridPosition = "middle";
    	amChartConfig.legend.align = "left";
 		 }
    if(typeof AmCharts == 'undefined'){
       angelCake.loadJS('/angelCake/dist/js/extras/amcharts/amcharts.js',function(){
        angelCake.loadJS('/angelCake/dist/js/extras/amcharts/funnel.js',function(){
          angelCake.loadJS('/angelCake/dist/js/extras/amcharts/serial.js',function(){
            angelCake.loadJS('/angelCake/dist/js/extras/amcharts/pie.js',function(){
              angelCake.loadJS('/angelCake/dist/js/extras/amcharts/plugins/responsive/responsive.min.js',function(){
                return AmCharts.makeChart( divID, amChartConfig);
              });
            });
          });
        });
      });
     }else{
      return AmCharts.makeChart( divID, amChartConfig);
     }
    
  };



